// Date Format yyyy-mm-dd
export const getFormattedDate = (date) => {
  const d = new Date(date)

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  const month = d.getMonth()
  const day = d.getDate()
  const year = d.getFullYear()

  return `${months[month]} ${day}, ${year} `
}

export function getFormatTime (date) {
  const d = new Date(date)

  let hours = d.getHours()
  let minutes = d.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'

  hours = hours % 12
  hours = hours ? hours : 12
  minutes = minutes < 10 ? `0${minutes}` : minutes

  return `${hours}:${minutes} ${ampm}`
}

export function secondsToHMS (sec) {
  const d = Math.floor(sec / 86400)
  const h = Math.floor(sec % 86400 / 3600)
  const m = Math.floor(sec % 3600 / 60)
  const s = Math.floor(sec % 3600 % 60)

  const days = d ? `${d}d, ` : ''
  const hours = h ? `${h}:` : ''
  const minutes = m ? ((m  < 10 && h) ? `0${m}` : m) : '00'
  const seconds = s < 10 ? `0${s}` : s

  return `${days}${hours}${minutes}:${seconds}`
}

export function secondsToHMSReader (sec) {
  if (!sec) {
    return ''
  }

  const d = Math.floor(sec / 86400)
  const h = Math.floor(sec % 86400 / 3600)
  const m = Math.floor(sec % 3600 / 60)
  const s = Math.floor(sec % 3600 % 60)

  const days = d ? `${d}d` : ''
  const hours = h ? `${h}h` : (d ? '0h' : '')
  const minutes = m ? `${m}m` : (h ? '0m' : '')
  const seconds = `${s}s`

  return `${days} ${hours} ${minutes} ${seconds}`
}

export function getDateLatestSunday (date = new Date()) {
  const currentDate = new Date(date)
  return new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay()))
}

export function getDateNextSaturday (date = new Date()) {
  const sunday = getDateLatestSunday(date)
  return new Date(sunday.setDate(sunday.getDate() + 6))
}

export function formatDurationShort (seconds) {
  if (seconds === null || typeof seconds === 'undefined') {
    return '-'
  }

  const parsedSeconds = Number(seconds)

  if (!Number.isFinite(parsedSeconds)) {
    return '-'
  }

  if (parsedSeconds === 0) {
    return '-'
  }

  if (parsedSeconds > 0 && parsedSeconds < 1) {
    return '1s'
  }

  const normalizedSeconds = Math.floor(parsedSeconds)

  const minutes = Math.floor(normalizedSeconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  const remainingHours = hours % 24
  const remainingMinutes = minutes % 60

  if (days === 0 && remainingHours === 0 && remainingMinutes === 0) return `${normalizedSeconds}s`
  if (days === 0 && remainingHours === 0) return `${remainingMinutes}m`
  if (days === 0 && remainingMinutes === 0) return `${remainingHours}h`
  if (days === 0) return `${remainingHours}h ${remainingMinutes}m`
  if (remainingHours === 0 && remainingMinutes === 0) return `${days}d`
  if (remainingHours === 0) return `${days}d ${remainingMinutes}m`
  if (remainingMinutes === 0) return `${days}d ${remainingHours}h`

  return `${days}d ${remainingHours}h ${remainingMinutes}m`
}

export function timeAgo (dateString, dateNow = new Date(), extended = false, showTime = false) {
  if (!dateString) {
    return ''
  }

  const date = new Date(dateString)
  const seconds = Math.ceil((Number(dateNow) - Number(date)) / 1000)

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60
  }

  if ((dateNow - date) > intervals.day * 1000 && extended) {
    const date = getFormattedDate(dateString)
    const time = getFormatTime(dateString)

    return showTime ? `${date} ${time}` : date
  }

  for (const [unit, interval] of Object.entries(intervals)) {

    const count = Math.floor(seconds / interval)
    if (count >= 1) {
      return `${count} ${unit}${count === 1 ? '' : 's'} ago`
    }
  }

  return 'less a minute ago'
}

export function getFormattedDateTimeUTC (dateString) {
  if (!dateString) {
    return ''
  }

  return `${new Date(dateString).toUTCString().replace('GMT', 'UTC')}`
}

export function isImageFormat (fileFormat) {
  return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(fileFormat)
}

export function isVideoFormat (fileFormat) {
  return (/\.(mp4|webm|ogv)$/i).test(fileFormat)
}

export function isFileFormat (fileFormat) {
  return (/\.(pdf)$/i).test(fileFormat)
}

export function getTrimmedText (text, num) {
  if (text.length > num) {
    return `${text.substring(0, num)}...`
  }

  return text
}

export function isInteger (value) {
  return /^\d+$/.test(value)
}

// Backend contract string returned by the support API when an admin acts on a
// user review that is now assigned to a different admin (HTTP 403). See OP-542.
export const DIFFERENT_ADMIN_ASSIGNED_ERROR = 'Different admin assigned'

export function isDifferentAdminAssignedError (error) {
  return error?.response?.status === 403 &&
    error?.response?.data?.error === DIFFERENT_ADMIN_ASSIGNED_ERROR
}

export function generateId () {
  return `_${  Math.random().toString(36).substring(2, 9)}`
}

export function dataURLtoFile (dataurl, filename) {
  const  arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[arr.length - 1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type:mime })
}

export function convertBytesToMb (bytes) {
  return Number((bytes / (1024 * 1024)).toFixed(2))
}

export function formatWeekLabel (week) {
  const [start, end] = week.split(' - ')
  const startDate = new Date(start)
  const endDate = new Date(end)

  const options = { day: '2-digit', month: 'short' }
  const startFormatted = startDate.toLocaleDateString(undefined, options)
  const endFormatted = endDate.toLocaleDateString(undefined, options)

  if (startDate.getFullYear() === endDate.getFullYear()) {
    return `${startFormatted} - ${endFormatted}`
  } else {
    const yearOptions = { ...options, year: 'numeric' }
    const endFormattedWithYear = endDate.toLocaleDateString(undefined, yearOptions)
    return `${startFormatted} - ${endFormattedWithYear}`
  }
}

export function capitalizeSnakeParts (str) {
  return str.split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

export function minDate () {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function parseUtc (input) {
  if (!input) return null
  return input.includes('T') ? new Date(input) : new Date(`${input.replace(' ', 'T')  }Z`)
}

// Format: "dd.MM.yyyy HH:mm" in a given IANA timezone (e.g., "Asia/Yerevan")
export function formatDDMMYYYYHHmmInTz (utcString, tz) {
  if (!utcString) return '—'
  const d = parseUtc(utcString)
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(d)
  const by = Object.fromEntries(parts.map(p => [p.type, p.value]))
  return `${by.day}.${by.month}.${by.year} ${by.hour}:${by.minute}`
}

// Optional: “GMT+4” or similar, for a separate column
export function tzShortNameAt (utcString, tz) {
  const d = parseUtc(utcString)
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'short',  // 'long' also works
    hour: '2-digit',
    minute: '2-digit'
  }).formatToParts(d)
  const tzPart = parts.find(p => p.type === 'timeZoneName')
  return tzPart?.value ?? tz  // fallback to IANA if not available
}

export function parseNoteLinks (text) {
  if (!text) return ''

  const escapeHtml = value => value.replace(/[&<>"']/g, char => {
    switch (char) {
    case '&': return '&amp;'
    case '<': return '&lt;'
    case '>': return '&gt;'
    case '"': return '&quot;'
    case '\'': return '&#39;'
    default: return char
    }
  })

  const patterns = [
    { pattern: /ps:(\d+)/g, url: '/users/$1', label: 'PS User', prefix: 'ps', badgeText: 'PS: $1' },
    { pattern: /hc:(\d+)/g, url: '/hc-user/$1', label: 'HeyCash User', prefix: 'hc', badgeText: 'HeyCash: $1' },
    { pattern: /ts:(\d+)/g, url: '/ts-user/$1', label: 'TopSurvey User', prefix: 'ts', badgeText: 'TopSurvey: $1' },
    { pattern: /po:(\d+)/g, url: '/po-user/$1', label: 'PrimeOpinion User', prefix: 'po', badgeText: 'PrimeOpinion: $1' },
    { pattern: /fs:(\d+)/g, url: '/fs-user/$1', label: 'FiveSurvey User', prefix: 'fs', badgeText: 'FiveSurvey: $1' },
    { pattern: /es:(\d+)/g, url: '/es-user/$1', label: 'EarnStar User', prefix: 'es', badgeText: 'EarnStar: $1' },
    { pattern: /s:(\d+)/g, url: '/surveys/$1', label: 'Survey', prefix: 's', badgeText: 'Survey: $1' },
    { pattern: /o:(\d+)/g, url: '/offers/$1', label: 'Offer', prefix: 'o', badgeText: 'Offers: $1' }
  ]

  let parsedText = escapeHtml(text)

  patterns.forEach(({ pattern, url, label, prefix, badgeText }) => {
    parsedText = parsedText.replace(pattern, (_match, id) => {
      const badgeTextWithId = badgeText.replace('$1', id)
      const routeWithId = url.replace('$1', id)
      return `<span class="badge badge-primary note-badge" data-route="${routeWithId}" data-prefix="${prefix}" data-id="${id}" title="${label} ${id}" style="cursor: pointer; margin: 0 2px;">${badgeTextWithId}</span>`
    })
  })

  return parsedText
}
